import { toDataSourceRequestString } from "@progress/kendo-data-query";
import { createApi } from "@reduxjs/toolkit/query/react";
import type { ListAdminPromotionEventsRequest, ListAdminPromotionEventsResponse } from "../../contracts";
import { baseQueryAdminWithAuth } from "../api";

export const adminPromotionEventApi = createApi({
    reducerPath: "adminPromotionEventApi",
    baseQuery: baseQueryAdminWithAuth,
    endpoints: builder => ({
        listPromotionEvents: builder.query<ListAdminPromotionEventsResponse, ListAdminPromotionEventsRequest>({
            query: body => ({
                url: `promotionevent/list?${toDataSourceRequestString(body)}`,
                method: "POST",
                body
            })
        })
    })
});

export const {
    useListPromotionEventsQuery,
    useLazyListPromotionEventsQuery
} = adminPromotionEventApi;
